import { connect } from 'react-redux';

import GraficaMovimiento from './GraficaMovimiento';
import { actions } from "../../../../../redux/modules/reportes/movimientos";

const ms2p = (state) => {
    return {
        ...state.reporte_movimientos,
        pais: state.usuario.me.pais
    };
};

const md2p = {
    ...actions
};

export default connect(ms2p, md2p)(GraficaMovimiento);